import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "contactView" }
const _hoisted_2 = { class: "mainTitle withArrow" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_arrow-L icon" }, null, -1)
const _hoisted_4 = { class: "contactDescription" }
const _hoisted_5 = { class: "contactData" }
const _hoisted_6 = { class: "col1_2" }
const _hoisted_7 = { class: "dataWithIcon" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_pointer icon" }, null, -1)
const _hoisted_9 = { class: "data" }
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_Land_line_phone icon" }, null, -1)
const _hoisted_14 = { class: "data" }
const _hoisted_15 = ["href"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "afna icon" }, "@", -1)
const _hoisted_17 = { class: "data" }
const _hoisted_18 = ["href"]
const _hoisted_19 = { class: "col1_2" }
const _hoisted_20 = { class: "dataWithIcon schedule" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_clock icon" }, null, -1)
const _hoisted_22 = { class: "data flex" }
const _hoisted_23 = { class: "day" }
const _hoisted_24 = { class: "hours" }
const _hoisted_25 = { class: "data flex" }
const _hoisted_26 = { class: "day" }
const _hoisted_27 = { class: "hours" }
const _hoisted_28 = { class: "data flex" }
const _hoisted_29 = { class: "day" }
const _hoisted_30 = { class: "hours" }
const _hoisted_31 = { class: "data flex" }
const _hoisted_32 = { class: "day" }
const _hoisted_33 = { class: "hours" }
const _hoisted_34 = { class: "data flex" }
const _hoisted_35 = { class: "day" }
const _hoisted_36 = { class: "hours" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "arrowBack",
        to: { name: 'FeedbackDashboard' }
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createTextVNode(_toDisplayString(_ctx.$t("tell_city_view.contact")), 1)
    ]),
    _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("contact.notice")), 1),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("ul", _hoisted_7, [
          _createElementVNode("li", null, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("a", {
                href: _ctx.googleMapsUrl,
                target: "_blank",
                class: "primary"
              }, [
                _createTextVNode(_toDisplayString(_ctx.$t("contact.city_name")), 1),
                _hoisted_11,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("contact.city_address")), 1),
                _hoisted_12,
                _createTextVNode(_toDisplayString(_ctx.$t("contact.city_post")), 1)
              ], 8, _hoisted_10)
            ])
          ]),
          _createElementVNode("li", null, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("a", {
                href: `tel:${_ctx.$t('contact.phone_number')}`,
                target: "_blank",
                class: "primary"
              }, _toDisplayString(_ctx.$t("contact.phone_number")), 9, _hoisted_15)
            ])
          ]),
          _createElementVNode("li", null, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("a", {
                href: `mailto:${_ctx.$t('contact.email')}`,
                target: "_blank",
                class: "primary"
              }, _toDisplayString(_ctx.$t("contact.email")), 9, _hoisted_18)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("ul", _hoisted_20, [
          _createElementVNode("li", null, [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t("contact.day.monday")), 1),
              _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t("contact.working_hours.monday")), 1)
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t("contact.day.tuesday")), 1),
              _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$t("contact.working_hours.tuesday")), 1)
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t("contact.day.wednesday")), 1),
              _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t("contact.working_hours.wednesday")), 1)
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t("contact.day.thursday")), 1),
              _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t("contact.working_hours.thursday")), 1)
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t("contact.day.friday")), 1),
              _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.$t("contact.working_hours.friday")), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}